const getPharmacyFormattedAddress = (
  address,
  cityName,
  stateName,
  autoSurround
) => {
  const pharmacyFormattedAddress = `${address}${
    cityName ? `${address ? ", " : ""}${cityName}` : ""
  }${stateName ? `${address || cityName ? ", " : ""}${stateName}` : ""}`;
  if (autoSurround && pharmacyFormattedAddress !== "") {
    return `(${pharmacyFormattedAddress})`;
  }else{
    return pharmacyFormattedAddress;
  }
};

/**
 * Splits a full name into first and last name components
 * @param {string} fullName - The full name to split
 * @returns {object} Object containing firstName and lastName
 */
const splitFullName = (fullName) => {
  if (!fullName || typeof fullName !== 'string') {
    return { firstName: '', lastName: '' };
  }

  // Trim whitespace and split by spaces
  const nameParts = fullName.trim().split(/\s+/);
  
  if (nameParts.length === 0) {
    return { firstName: '', lastName: '' };
  } else if (nameParts.length === 1) {
    // Only one name provided, treat as first name
    return { firstName: nameParts[0], lastName: '' };
  } else {
    // Multiple parts: first part is first name, rest is last name
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(' ');
    return { firstName, lastName };
  }
};

const sanitizeFileNamePart = (value) => {
  if (!value) return "";
  return String(value)
    .replace(/[<>:"/\\|?*\x00-\x1f]/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

const getAttachmentExtension = (attachment) => {
  const mime = attachment.fileType || attachment.filetype || "";
  if (mime.includes("/")) {
    return mime.split("/")[1];
  }
  if (
    attachment.type &&
    attachment.type !== "url" &&
    attachment.type !== "link"
  ) {
    return attachment.type;
  }
  return "bin";
};

const buildAttachmentFileName = ({ rxNumber, prescribedDrug, extension }) => {
  const rx = sanitizeFileNamePart(rxNumber);
  const drug = sanitizeFileNamePart(prescribedDrug);
  const ext = extension || "pdf";

  let name = "";
  if (rx && drug) {
    name = `${rx} - ${drug}`;
  } else if (rx) {
    name = rx;
  } else if (drug) {
    name = drug;
  } else {
    return `attachment.${ext}`;
  }

  const maxLength = 200;
  if (name.length > maxLength) {
    name = name.slice(0, maxLength).trim();
  }

  return `${name}.${ext}`;
};

const downloadAttachment = (attachment, { rxNumber, prescribedDrug } = {}) => {
  if (!attachment?.content) return;

  if (attachment.type === "url" || attachment.type === "link") {
    window.open(attachment.content, "_blank");
    return;
  }

  const extension = getAttachmentExtension(attachment);
  const fileName = buildAttachmentFileName({
    rxNumber,
    prescribedDrug,
    extension,
  });

  const link = document.createElement("a");
  link.href = attachment.content;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default {
  getPharmacyFormattedAddress,
  splitFullName,
  downloadAttachment,
};
